module.exports = __webpack_public_path__ + "static/nba-a8158a28610c09e5fcb96321a4c69738.svg";